import { default as Item, View } from './item'
import global from '@/util/mixin/global'
import listComponent from '@/util/proto/listComponent'

export default {
  mixins: [global],
  extends: listComponent,

  data() {
    return {
      columns: [{
          type: 'index',
          width: 65,
          title: '序号',
          align: 'center'
        },
        {
          title: '设备名称',
          key: 'name',
          minWidth: 120,
        },
        {
          title: '设备类型',
          key: 'deviceTypeText',
          minWidth: 150,
        },
        {
          title: '设备厂商',
          key: 'platformText',
          minWidth: 150,
        },
        {
          title: '设备型号',
          key: 'deviceModel',
          minWidth: 150,
        },
        {
          title: '设备编号',
          key: 'deviceSn',
          minWidth: 120,
        },
        {
          title: '所属单位',
          key: 'companyName',
          minWidth: 100,
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {

            let node = []
            //if( this.$a('company.inspection.query') ){
            node.push(<a on-click={()=>this.view(row)}>查看</a>)
            //}

            //if(this.$a('company.inspection.edit')){
            node.push(<a on-click={()=>this.edit(row)}>编辑</a>)
            //}

            //if(this.$a('company.inspection.remove')){
            node.push(<a on-click={()=>this.remove(row)}>删除</a>)
            //}

            return this.$utils.link(node, <Divider type="vertical" />)

          }
        }
      ],
      data: [],
      params: {
        deviceSn: null,
        companyName: null,
        deviceType: null
      },
      loading: false
    }
  },
  computed: {
    importUrl() {
      return this.$request.deviceImportUrl()
    }
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {

    search() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.companyDevices(params).then(resp => {
        this.loading = false
        if (resp.code == 0) {
          this.data = this.$utils.conv(resp.data.list, { 'deviceType': 'companyDeviceType', 'platform': 'companyDevicePlatform' })
          this.page.total = resp.data.total || 0
        } else {
          this.$Message.error({ content: resp.msg })
        }
      })
    },

    edit(row) {
      this.$refs['item'].init(row.id)
    },
    view(row) {
      this.$refs['itemView'].init(row.id)
    },
    create() {
      this.$refs['item'].init(0)
    },
    imports() {

    },
    remove(row) {
      this.$ui.confirm(this.$request.companyDeviceDelete, `确定删除 ${row.name} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.list()
        } else {
          this.$Notice.error({
            title: '删除发生错误',
            desc: resp.msg,
          });
        }
      })
    },

    toggle(row) {

    },
    location(row) {
      this.$dialog({
        className: 'paddingless',
        width: '600px',
        render: (h) => {
          return h(deviceLocation, { props: { id: row.id } })
        }
      })
    },
    reset() {
      this.$utils.fill(this.params, this.def)
      this.search()
    },

    handleUpdate() {
      this.search()
    },


    handleImportComplete(resp) {
      if (resp.code) {
        this.$Modal.warning({ title: '设备导入', content: resp.msg.replace(/[\r\n;]/g, '<br />') })
      } else {
        this.$Notice.success({ title: '导入成功', duration: 20, desc: '您可在 基础设置->导入管理 中查看处理结果！' })

      }
      this.search()
    }
  },
  /*
 <Upload :action="importUrl" style="display: inline-block;">
              <Button icon="md-cloud-upload"  @click="imports()">导入</Button>
            </Upload> -->
            <sl-upload-file :action="importUrl" :enable-reply="false" @complete="handleImportComplete">
              <template v-slot:tip>
                <sl-a href="@template/device.xlsx" name="设备导入模板.xlsx">模板下载</sl-a>
              </template>
              <Button icon="ios-cloud-upload-outline">导入</Button>
            </sl-upload-file>
            <Button style="margin-left:6px;" type="primary" icon="md-add" @click="create()">新增</Button>
  */
  render() {
    const slots = {
      action:()=>{
        return [
          // <sl-upload-file action={this.importUrl} enable-reply={false} on-complete={this.handleImportComplete}>
          //     <template slot="tip">
          //       <sl-a href="@template/device.xlsx" name="设备导入模板.xlsx">模板下载</sl-a>
          //     </template>
          //     <Button icon="ios-cloud-upload-outline">导入</Button>
          //   </sl-upload-file>,
          <Button style="margin-left:8px;" type="primary" icon="md-add" on-click={this.create}>新增</Button>
        ]
      }
    }

    return <sl-page>
          <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset} scopedSlots={slots}>
            <sl-search-item label="">
              <i-input v-model={this.params.deviceSn} placeholder="设备编号" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.companyName} placeholder="所属单位" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-select dict="companyDeviceType" v-model={this.params.deviceType} placeholder="设备类型" />
            </sl-search-item>
          </sl-search>
        </div>
        
        <div class="pg-bd">
          <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange}>
          </sl-table>
        </div>
        <Item ref="item" on-update={this.handleUpdate} />
        <View ref="itemView" />

     </sl-page>
  }
}